import {IWidgetResponse} from "../api/odds-comparison";
import {setUpTranslations} from "./translations";
import {IWidgetData} from "./types";
import {setUpWidgetMetas} from "./widget-meta";

export const processResponse = function(r: IWidgetResponse): IWidgetData {

  // Save translation to translations storage
  setUpTranslations(r.translations);

  setUpWidgetMetas(r.widgetMetas);

  return {
    widgetTypeId: r.widgetTypeId,
    clickableRows: r.clickableRows,
    showTeamLogos: r.showTeamLogos,
    clientId: r.clientId,
    id: r.id,
    languageId: r.languageId,
    linkTemplate: r.linkTemplate,
    name: r.name,
    oddsFormat: r.oddsFormat,
    outLinkFolder: r.outLinkFolder ?? null,
    providerLogoTemplate: r.providerLogoTemplate,
    providerLogoType: r.providerLogoType,
    status: r.status,
    theme: r.theme,
    userId: r.userId,
    widgetCompetitions: r.widgetCompetitions,
    competitionIds: r.widgetCompetitions.map(competition => competition.competitionId),
    widgetProviders: r.widgetProviders.map(provider => {
      return { id: provider.providerId, slug: provider.slug }
    }),
    widgetSports: Array.from(new Set(r.widgetCompetitions.map(competition => competition.competition.sportId))),
    widgetStyles: r.widgetStyles,
    format: r.format,
    channel: r.channel,
    channelOutLinkFolder: r.channelOutLinkFolder,
  }
}